import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReactNode } from 'react';

interface CustomHeaderContentState {
  content: ReactNode | null;
}

const initialState: CustomHeaderContentState = {
  content: null,
};

interface State {
  customHeaderContent: CustomHeaderContentState;
}

const customHeaderContentSlice = createSlice({
  name: 'customHeaderContent',
  initialState,
  reducers: {
    setCustomHeaderContent(state, action: PayloadAction<ReactNode | null>) {
      state.content = action.payload;
    },
  },
});

export const { setCustomHeaderContent } = customHeaderContentSlice.actions;
export const selectCustomHeaderContent = ({ customHeaderContent }: State) =>
  customHeaderContent.content;

export default customHeaderContentSlice.reducer;
